import type { Command } from 'commander';
import { registerSessionsList } from './list';
import { registerSessionsRevoke } from './revoke';

export function registerSessionsCommand(program: Command): void {
	const sessions = program.command('sessions').description('List and revoke your personal login sessions (devices)');
	registerSessionsList(sessions);
	registerSessionsRevoke(sessions);
}
